import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useExperiment } from "@ottatech/analytics";
import { ThemeContext } from "styled-components";

import { ApplyModal } from "components/ApplyModal";

export function ApplyModalWrapper(): React.ReactElement {
  const { jobId: jobExternalId } = useParams();
  const { isBatchEndWithExperiment } = useContext(ThemeContext);
  const navigate = useNavigate();

  const {
    variant: savedJobsBatchEndJourneyVariant,
    loading: savedJobsBatchEndJourneyLoading,
  } = useExperiment("20221116_SAVED_JOBS_BATCH_END_JOURNEY");
  const savedJobsBatchEndJourneyExperimentEnabled =
    savedJobsBatchEndJourneyVariant === "variant" &&
    !savedJobsBatchEndJourneyLoading;

  const handleClose = () => {
    navigate(
      savedJobsBatchEndJourneyExperimentEnabled && isBatchEndWithExperiment
        ? "/jobs/batch-end"
        : "/"
    );
  };

  return (
    <ApplyModal
      jobExternalId={jobExternalId as string}
      onClose={handleClose}
      type="DASHBOARD"
    />
  );
}
